const testimonials = [
  {
    name: "Dr. Kwame Osei",
    role: "Headmaster, St. Augustine's College",
    quote: "VelTech reduced our admin paperwork by 80%. The system helped us identify students who needed extra support before BECE. All of them passed.",
  },
  {
    name: "Mrs. Grace Mensah",
    role: "Administrator, Wesley Girls' High School",
    quote: "Fee collection went from a nightmare to automated. Parents now pay via Mobile Money and we track everything in real-time. Outstanding fees dropped by 60%.",
  },
  {
    name: "Rev. Dr. Charles Boateng",
    role: "Headmaster, Prempeh College",
    quote: "The best investment we made. Parents love the transparency. Teachers love how easy it is. And our WASSCE pass rate increased from 78% to 94% in 2 years.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-white py-24 lg:py-32 overflow-hidden">
      <div className="blob-emerald" style={{ top: '-20%', right: '10%' }} />
      <div className="blob-amber" style={{ bottom: '-10%', left: '-5%' }} />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0A0A0A] mb-4"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="testimonials-heading"
          >
            What Schools Say
          </h2>
          <p
            className="text-base text-gray-500 max-w-lg mx-auto font-medium"
            style={{ fontFamily: "'Satoshi', sans-serif" }}
          >
            Real feedback from headmasters and administrators
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="hover-lift bg-gray-50 border-2 border-gray-100 p-8"
            >
              <p
                className="text-gray-600 text-base leading-relaxed mb-8 font-medium"
                style={{ fontFamily: "'Satoshi', sans-serif" }}
              >
                &ldquo;{t.quote}&rdquo;
              </p>
              <div>
                <div
                  className="text-[#0A0A0A] font-black text-sm uppercase"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {t.name}
                </div>
                <div className="text-gray-400 text-xs mt-1 font-medium" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
